import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';

import { Quote } from '@sm360/widget-commons-vehicle';
import { NoSSR } from '@sm360/widget-commons-general';
import 'trade-in-360/components/InstantEstimate/InstantEstimate.scss';

// The webpackChunkName name here is intended to be public. Webpack will use it to name files in production and development modes.
const OfficialTradeInModal = lazy(() =>
    import(/* webpackChunkName: "OfficialTradeInModal" */ 'trade-in-360/components/OfficialTradeInModal/OfficialTradeInModal.jsx')
);

class OfficialTradeIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            tradeInVehicle: {},
        };
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose() {
        this.setState({ isModalOpen: false });
    }

    render() {
        return (
            <NoSSR>
                <Suspense fallback="">
                    <OfficialTradeInModal
                        openModal={this.state.isModalOpen}
                        onClose={this.handleClose}
                        tradeInVehicle={this.state.tradeInVehicle}
                        quote={this.props.quote}
                        config={this.props.config}
                    />
                </Suspense>
            </NoSSR>
        );
    }
}

OfficialTradeIn.defaultProps = {
    quote: null,
    config: {},
};

OfficialTradeIn.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModel),
    config: PropTypes.object,
};

OfficialTradeIn.displayName = 'OfficialTradeIn';

export default OfficialTradeIn;
